import { useQueryClient } from "@tanstack/react-query";
import React, { useState, useCallback } from "react";
import { archiveBoard } from "../../../../../sevices/apiBoards";
import { objectToFormData } from "../../../../../utils";
import { Tooltip, Typography } from "@mui/material";
import { TooltipName } from "../../../../../utils/Enums";
import FormDialog from "../../../../../components/Dialog/FormDialog";
import useMutate from "../../../../../hooks/useMutate";

export const ArchiveBoard = React.memo(function ArchiveBoard({ isArchive, id }) {
  const [archiveStatus, setArchiveStatus] = useState(isArchive);
  const queryClient = useQueryClient();
  const [loading, setLoading] = useState(false);
  const [archiveDialog, setArchiveDialog] = useState(false);

  const { mutate: archiveMutate } = useMutate(
    archiveBoard,
    ["boards"],
    () => {},
    () => {
      queryClient.invalidateQueries({
        queryKey: ["boardName", id],
      });
      setArchiveStatus((data) => !data);
      setLoading(false);
      handleCloseDialog();
    },
    (error) => {
      console.error("Error Delete Attachments", error);
      setLoading(false);
      handleCloseDialog();
    }
  );

  const handleCloseDialog = useCallback(() => {
    setArchiveDialog(false);
  }, []);

  const submitArchiveDialog = useCallback(() => {
    const data = objectToFormData({ is_archive: archiveStatus, board_id: id });
    setLoading(true);
    archiveMutate({ id, data });
  }, [archiveStatus, id, archiveMutate]);

  const handleOpenDialog = useCallback(()=>{
    setArchiveDialog(true);
  },[]);
  
  return (
    <div className="w-100 d-flex justify-content-center">
      <Tooltip
        title={
          isArchive
            ? TooltipName.MANAGE_BOARD.UNARCHIVE_THIS_BOARD
            : TooltipName.MANAGE_BOARD.ARCHIVE_THIS_BOARD
        }
      >
        <label className="switch">
          <input
            type="checkbox"
            value={archiveStatus}
            checked={archiveStatus}
            onChange={handleOpenDialog}
          />
          <div className="slider"></div>
        </label>
      </Tooltip>
      {archiveDialog && (
        <FormDialog
          open={archiveDialog}
          handleClose={handleCloseDialog}
          handleSubmit={submitArchiveDialog}
          loading={loading}
          buttonTxt={!isArchive ? "Restore" : "Archive"}
          title={
            !isArchive
              ? "Confirmation: Restore Board"
              : "Confirmation: Archive Board"
          }
          alignActions={"center"}
          cancelBtn={true}
          fullWidth={true}
        >
          <Typography className="align_text_center mb-2 ">
            {!isArchive
              ? "Are you sure you want to restore the board ?"
              : "Are you sure you want to archive this board? Archiving the board will hide it from view and move it to the archive section. You can always restore it later if needed. Please confirm your action."}
          </Typography>
        </FormDialog>
      )}
    </div>
  );
});
